import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { RouterModule, Routes, Router } from '@angular/router';
import { ConfirmEmailComponent } from '../confirm-email/confirm-email.component';
import { ConfirmEmailService } from '../services/confirm-email.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit{

  userForm: FormGroup;

  constructor(private authService : AuthService,private formBuilder: FormBuilder,
    private router: Router,private snackBar: MatSnackBar,private confirmEmail : ConfirmEmailService) { }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    this.userForm = this.formBuilder.group({
      'fullname': ['', [
        Validators.required
        ]
      ],
      'email': ['', [
          Validators.required,
          Validators.email
        ]
      ],
      'password': ['', [
        Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$'),
        Validators.minLength(6),
        Validators.maxLength(25)
      ]
    ],
    'terms' :['', [
          Validators.required
      ]
    ]
    });

    this.userForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.onValueChanged(); // reset validation messages
  }

   // Updates validation state on form changes.
   onValueChanged(data?: any) {
    if (!this.userForm) { return; }
    const form = this.userForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.dirty && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

 formErrors = {
    'email': '',
    'password': '',
    'terms' : ''
  };

  validationMessages = {
    'email': {
      'required':      'Email is required.',
      'email':         'Email must be a valid email'
    },
    'password': {
      'required':      'Password is required.',
      'pattern':       'Password must be include at one letter and one number.',
      'minlength':     'Password must be at least 6 characters long.',
      'maxlength':     'Password cannot be more than 40 characters long.',
    },
    'terms': {
      'required':      'You need to accept terms and condition first.'
    }
  };



  /**
   * This method will handel email id and password and send data in encription
   * @param value Email and Password Object
   */
  registerUser(signUpType){
    this.tryEmailSignup(this.userForm.value);
  }

  /**
   * Register User with email and password
   */
  tryEmailSignup(value){
    console.log(value);
    this.authService.emailSignup(value)
    .then(res => {
          this.onEmailSignupSuccess(res);
    }, err => {
        this.onEmailSignupError(err);
    })
  }


  onEmailSignupSuccess(res) : void {
    console.log(res);
    this.confirmEmail.showConfirmEmail('Please confirm your email sent to your email id.'); 
    if(!this.authService.isUserEmailVerified()){
      this.authService.sendEmailVerification();
    }
   // this.dialogRef.close("Success");
    this.router.navigate(['home']);
  }



  onEmailSignupError(err) : void {
    console.log(err);
    this.snackBar.open(err.message, 'Try Again', {
      duration: 5000,
    });
  }

}
